module.exports = __webpack_public_path__ + "static/img/diyiimg1.e60c78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg1.png
// module id = E6wm
// module chunks = 5